import { gql } from 'graphql-request'

export const GET_WRITING_OPTIONS = gql`
  query GetWritingList($page: Int, $limitPerPage: Int) {
    getWritingList(page: $page, limitPerPage: $limitPerPage) {
      page
      data {
        id
        title
      }
    }
  }
`
